import React, { Component, Fragment } from 'react';
import { Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { getClient } from '../../apollo';
import gql from 'graphql-tag';
import { PurchaseOrderObject } from '../../page/fragments/PurchaseOrders';
import { withSnackbarMessage } from '../../context/SnackbarMessage';
import { compose } from '../../reactApolloCompat';
import { isRelatedObjectDefined } from '../../util/bookable';
import PrimaryButton, { AltButton, OutlineButton, SaveButton } from '../form/PrimaryButton';
import QuotesIcon from '../icon/QuotesIcon';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import UsdCircleIcon from '../icon/UsdCircleIcon';
import DialogContent from '@mui/material/DialogContent';
import Grid from '../form/Grid';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '../icon/CloseIcon';
import { joinDefined, prettyPrice } from '../../util/strings';
import { round } from '../../util/objects';
import { GST } from '../../util/products';
import TableData from '../form/TableData';
import Hidden from '../Hidden';
import Spinner from '../Spinner';

class PurchaseInvoiceModal extends Component {
    state = {
        open: false,
        loaded: false,
        Invoice: null
    };

    static reCalcTable(data) {
        data.SubTotal = (data.Qty * 1 * (!!data.needGST ? data.Price / (GST + 1) : data.Price)).toFixed(2);
        data.GST = !!data.needGST ? (data.SubTotal * GST).toFixed(2) : 0;
        data.Total = Number(data.Qty * data.Price).toFixed(2);
        return data;
    }

    componentDidMount() {
        const { hasPurchaseOrder } = this.props;
        const { PO } = this.state;
        if (PO !== hasPurchaseOrder.ID) {
            getClient()
                .query({ query: readMyPurchaseOrder, variables: { id: hasPurchaseOrder.ID } })
                .then(result => {
                    const foo = { loaded: true };
                    if (!!result.data.readOnePurchaseOrder) {
                        foo.Invoice = result.data.readOnePurchaseOrder.Invoice;
                    }
                    this.setState(foo);
                });
        }
    }

    render() {
        const { classes, hasPurchaseOrder = false } = this.props;
        const { Invoice, loaded, open } = this.state;
        const hasInvoice = !!Invoice && isRelatedObjectDefined(Invoice);
        const hasXero = !!hasInvoice && Invoice.XeroID;

        if (!hasPurchaseOrder) return 'Error: No PO or Bill found.';

        if (!!hasInvoice && !!open)
            return (
                <Dialog
                    classes={{ paper: classes.root }}
                    open={open}
                    onClose={this.onClose}
                    aria-labelledby={'PurchaseOrderModal'}
                >
                    <form noValidate onSubmit={e => this.onSubmit(e)}>
                        {this.renderInvoice()}
                    </form>
                </Dialog>
            );

        if (!loaded) return 'Loading...';
        return (
            (!!hasInvoice &&
                (hasXero ? (
                    <OutlineButton forModal onClick={this.showInvoiceModal}>
                        <QuotesIcon />
                        View Bill #{Invoice.ID}...
                    </OutlineButton>
                ) : (
                    <PrimaryButton forModal onClick={this.showInvoiceModal}>
                        <QuotesIcon />
                        Submit Bill #{Invoice.ID}...
                    </PrimaryButton>
                ))) || (
                <AltButton onClick={this.generateBill}>
                    <QuotesIcon />
                    Generate Bill
                </AltButton>
            )
        );
    }

    onCancel = reload => {
        const { form } = this.props;
        if (!!form && !!reload && form.doRefetch) {
            const me = this;
            form.doRefetch(() => me.clearState());
        } else {
            this.clearState();
        }
    };

    clearState() {
        this.setState({ open: false, loaded: true });
    }

    renderInvoiceItems() {
        const { classes } = this.props;
        const { Invoice } = this.state;
        let orderTotal = 0;
        const data = Invoice.InvoiceItems.map(e => {
            // if xero has processed invoice, use their data.
            // if not xero (e.g. legacy data or unsaved) reconstruct using current catalogue.
            const Item =
                (isRelatedObjectDefined(e.Variation) && e.Variation) ||
                (isRelatedObjectDefined(e.Product) && e.Product);
            const needGST = e.LineAmount ? !!e.GstAmount : !!Item ? Item.ITC : true;
            const Price = e.LineAmount // price needs to include any taxes
                ? round((e.LineAmount + e.GstAmount) / e.Quantity)
                : round(needGST ? e.Price * (GST + 1) : e.Price);
            const title =
                e.Product.Title + (!!isRelatedObjectDefined(e.Variation) ? ' | ' + Item.ShortDescription : '');
            const displayData = {
                data: {
                    Code: Item.InternalItemID,
                    Description: title,
                    Price,
                    Qty: Number(Number(e.Quantity).toFixed(0)),
                    needGST: !!needGST
                }
            };
            displayData.data = PurchaseInvoiceModal.reCalcTable(displayData.data);
            orderTotal += Number(displayData.data.Price) * Number(displayData.data.Qty);
            return displayData.data;
        });

        const columns = [
            { id: 'Code', label: 'Item Code/SKU' },
            { id: 'Description', label: 'Description of product or service' },
            /*{
                id: 'Cost',
                label: 'Cost',
                render: val => {
                    return prettyPrice(val);
                },
                styles: { textAlign: 'right' }
            },*/
            {
                id: 'Price',
                label: 'Price',
                render: (val, row, rowIndex) => {
                    return prettyPrice(val);
                },
                styles: { width: 1 }
            },
            { id: 'Qty', label: 'Quantity', styles: { textAlign: 'right', width: 1 } },
            // {
            //     id: 'SubTotal',
            //     label: 'Subtotal (exGST)',
            //     render: (val, row, rowIndex) => {
            //         return prettyPrice(val);
            //     },
            //     styles: { textAlign: 'right', width: '5.5rem' }
            // },
            {
                id: 'GST',
                label: 'GST',
                render: (val, row, rowIndex) => {
                    return !!row.needGST ? prettyPrice(val) : 'FREE';
                },
                styles: { textAlign: 'right', width: '5rem' }
            },
            {
                id: 'Total',
                label: 'Line Total',
                render: (val, row, rowIndex) => {
                    return prettyPrice(val);
                },
                styles: { textAlign: 'right', width: '5.5rem' }
            }
        ];

        return (
            <div>
                <Typography variant={'display1'}>Bill Total: {prettyPrice(orderTotal)}</Typography>
                <div className={classes.dataList}>
                    <TableData
                        columns={columns}
                        data={data}
                        footer={[
                            { id: 'Qty', label: 'TOTAL' },
                            {
                                id: 'GST',
                                render: (column, data) => {
                                    const sum = data
                                        .map(obj => {
                                            return 1 * obj['GST'];
                                        })
                                        .reduce((sum, obj) => {
                                            return sum + obj;
                                        });
                                    return prettyPrice(sum);
                                }
                            },
                            {
                                id: 'Total',
                                render: (column, data) => {
                                    const sum = data
                                        .map(obj => {
                                            return 1 * obj['Total'];
                                        })
                                        .reduce((sum, obj) => {
                                            return sum + obj;
                                        });
                                    return <b>{prettyPrice(sum)}</b>;
                                }
                            }
                        ]}
                    />
                </div>
            </div>
        );
    }

    renderInvoice() {
        const { classes, labelSupplier = 'Supplier' } = this.props;
        const { Invoice, loaded } = this.state;
        const contactName =
            joinDefined([Invoice.Customer.FirstName, Invoice.Customer.MiddleName, Invoice.Customer.Surname], ' ') ||
            Invoice.Customer.CustomerName;
        return (
            <Fragment>
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        overflow: 'hidden',
                        pointerEvents: 'none'
                    }}
                >
                    <UsdCircleIcon
                        style={{
                            opacity: 0.025,
                            width: 300,
                            height: 300,
                            position: 'absolute',
                            right: -24,
                            top: 124,
                            transform: 'rotate(20deg)',
                            zIndex: 0
                        }}
                    />
                </div>
                <DialogTitle className={classes.diagHeader}>
                    <Hidden smDown>
                        <UsdCircleIcon className={classes.starButton} />
                        <div className={classes.diagHeaderTitle}>
                            {labelSupplier}:<strong> {contactName}</strong>
                        </div>
                        <div className={classes.diagHeaderSubtitle}>
                            {Invoice.XeroID ? 'View' : 'Submit'} Bill #{Invoice.ID}
                        </div>
                    </Hidden>
                    <Hidden smUp>
                        <div className={classes.diagHeaderTitle}>
                            {Invoice.XeroID ? 'View' : 'Submit'} Bill #{Invoice.ID} for {labelSupplier}
                        </div>
                    </Hidden>
                </DialogTitle>
                <DialogContent className={classes.content}>
                    <Grid container spacing={2} pc={1} style={{ margin: 0 }}>
                        <Grid item xs={12}>
                            {this.renderInvoiceItems()}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.diagActions}>
                    <OutlineButton onClick={() => this.setState({ open: false })}>
                        <CloseIcon />
                        <Hidden smDown>Close</Hidden>
                    </OutlineButton>

                    <div style={{ textAlign: 'right' }}>
                        {(!Invoice.XeroID && (
                            <SaveButton onClick={e => this.generateBill(e)} disabled={!loaded}>
                                {loaded ? (
                                    <Fragment>
                                        <UsdCircleIcon />
                                        <Hidden smDown>Submit Bill</Hidden>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <Spinner />
                                        <Hidden smDown>Submitting...</Hidden>
                                    </Fragment>
                                )}
                            </SaveButton>
                        )) || (
                            <div>
                                <strong>{Invoice.XeroReference}</strong>
                                <br />
                                Status: <strong>{Invoice.XeroStatus}</strong>
                            </div>
                        )}
                    </div>
                </DialogActions>
            </Fragment>
        );
    }

    showInvoiceModal = e => {
        e.preventDefault();
        const { hasPurchaseOrder } = this.props;
        const { Invoice } = this.state;
        if (isRelatedObjectDefined(hasPurchaseOrder) && isRelatedObjectDefined(Invoice)) {
            this.setState({ open: true });
        }
    };

    generateBill = e => {
        e.preventDefault();
        const { hasPurchaseOrder } = this.props;
        const that = this;
        if (isRelatedObjectDefined(hasPurchaseOrder)) {
            this.setState({ loaded: false });
            return submitToXero(hasPurchaseOrder.ID).then(
                moreData => {
                    if (moreData && moreData.data.submitPurchaseOrderToXero) {
                        this.props.setSnackbarMessage('Success, your bill was submitted.', true);
                        this.onCancel(true);
                    }
                },
                subError => that.onGqlError('Failed to send bill to xero.', subError)
            );
        }
    };

    onGqlError(action, error) {
        this.setState({ loaded: true });
        if (error) console.error(error);
        this.props.setSnackbarMessage(action, false, null, new Error(error));
    }
}

export const readMyPurchaseOrder = gql`
    ${PurchaseOrderObject}
    query ReadOnePurchaseOrder($id: ID!) {
        readOnePurchaseOrder(ID: $id) {
            ...PurchaseOrderObject
        }
    }
`;

const submitToXeroMutation = gql`
    ${PurchaseOrderObject}
    mutation SubmitToXero($id: ID!) {
        submitPurchaseOrderToXero(ID: $id) {
            ...PurchaseOrderObject
        }
    }
`;

const submitToXero = async ID => {
    let asyncQuery;

    asyncQuery = await getClient().mutate({
        mutation: submitToXeroMutation,
        variables: {
            id: ID
        }
    });

    return asyncQuery;
};

const styles = ({ palette, spacing, funeralHome, breakpoints }) => ({
    root: {
        maxWidth: '800px',
        width: '100%',
        maxHeight: 'unset',
        [breakpoints.down('sm')]: {
            margin: spacing(1)
        }
    },
    diagHeader: {
        background: palette.contentForeground[funeralHome],
        padding: spacing(3)
    },
    diagHeaderTitle: {
        color: '#FFFFFF',
        fontSize: '16px',
        fontWeight: 'lighter',
        lineHeight: 'normal'
    },
    diagHeaderSubtitle: {
        color: '#FFFFFF',
        fontSize: '36px',
        fontWeight: 'initial',
        lineHeight: 'normal'
    },
    starButton: {
        width: '70px',
        height: '70px',
        float: 'right',
        color: 'rgba(255,255,255,0.5)'
    },
    content: {
        width: '100%',
        padding: spacing(3),
        paddingTop: `${spacing(3)}!important`,
        maxHeight: 'calc(100vh - 15rem)',
        overflow: 'auto',
        minHeight: 340,
        backgroundColor: '#fafafa',
        [breakpoints.down('sm')]: {
            maxHeight: 'calc(100vh - 12rem)',
            padding: spacing(1)
        }
    },
    diagActions: {
        padding: spacing(3),
        paddingTop: spacing(2),
        margin: 0,
        justifyContent: 'space-between'
    },
    regular: {
        fontSize: '16px',
        fontWeight: 'lighter'
    },
    greenButt: {
        border: '1px solid' + palette.button.save,
        backgroundColor: palette.button.save,
        '&:hover': {
            backgroundColor: palette.action.hover,
            color: palette.button.save
        }
    },
    dataList: {
        overflowY: 'auto',
        marginTop: 20,
        marginBottom: 30
    }
});

export default compose(withSnackbarMessage, withStyles(styles))(PurchaseInvoiceModal);
